import intPhoneNumber from '../js/int_phone_number.js'
import 'intl-tel-input/build/js/utils.js'
import uncoverPassword from '../js/uncover_password.js'
window.uncoverPassword = uncoverPassword

document.addEventListener("DOMContentLoaded",function(){
	// Getting Country data from HTTP header
	var visitor_country = $("#visitor-country").data('visitor-country');

	// Setting Country code for Phone
	if ($("#telephone").length) {
		var input = document.querySelector("#telephone");
		intPhoneNumber(visitor_country,input);
	}
});